/** @format */

import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TAPIGroupListSuccess } from "../../redux-modules/declarations/apis/groups";
import apiClient from "../../utils/apiClient";

export const apiGroupList = (): Promise<AxiosResponse<TAPIGroupListSuccess>> =>
  apiClient.get(API_ENDPOINTS.GROUP);
